import React from 'react';

const SubscribeSection = () => {
  return (
    <section
      className="subscribe-section"
      style={{ backgroundImage: 'url(/images/img16.jpg)' }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div className="section-heading section-heading-white">
              <h5 className="dash-style">STAY CONNECTED WITH PRINCE CABS</h5>
              <h2>GET INSTANT CAB ASSISTANCE</h2>
              <h4>
                Have questions or want to book a cab? Call us now and our team will assist you immediately.
              </h4>

              <div className="call-now">
                <a
                  href="tel:+919284304420"
                  className="btn btn-primary"
                  style={{
                    padding: '12px 24px',
                    fontSize: '16px',
                    backgroundColor: '#ff6600',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    textDecoration: 'none',
                    display: 'inline-block',
                    marginTop: '20px'
                  }}
                >
                  📞 Call Us Now: +91 9284304420
                </a>
              </div>

              <p style={{ marginTop: '15px' }}>
                Available 24/7 for bookings and inquiries. Prince Cabs — Reliable, Safe, On-Time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubscribeSection;
